import store from '@/user/store'
import i18n from '@/user/plugins/i18n'
import RouterHelpers from '@/user/helpers/router.helper'
import { scrollTo } from '@/user/homepage-integration'

/**
 * Error Service
 * @class ErrorService
 */
export default class ErrorService {
  constructor() {}

  /**
   * Error 상태 체크
   * @method
   * @memberof ErrorService
   * @param {object.<code:number, response:object>} onError 에러코드 및 응답 상태
   */
  static onError({ code, response } = {}) {
    try {
      store.getters['LoaderStore/loading'] && store.dispatch('LoaderStore/init')

      if (code === 'ECONNABORTED') return ErrorService.responseTimeout()

      this.errorTypeMap = new Map()
        .set(404, RouterHelpers.gotoNotFound)
        .set(409, () => ErrorService.displayErrorAlert({ response }))
        .set(400, () => ErrorService.displayErrorAlert({ response }))
        .set(500, RouterHelpers.gotoInternalServerError)
        .set(503, ErrorService.serviceUnavailable)
        .set(999, ErrorService.networkError)

      this.errorTypeMap.get(response.status)()
    } catch (ignore) {
      // console.log(ignore)
    }
  }

  /**
   * Timeout(408) Alert
   * @method
   * @memberof ErrorService
   */
  static responseTimeout() {
    ErrorService.displayErrorAlert({
      response: {
        status: 408,
        statusText: i18n.global.t('common.error.apiInternalErrorDesc'),
      },
    })
  }

  /**
   * Error Alert
   * @method
   * @memberof ErrorService
   * @param {object.<response:object>} displayErrorAlert 404, 500, 503, 999 에러
   */
  static displayErrorAlert({ response }) {
    scrollTo(0, 0)
    store.dispatch('AlertStore/showAlertModal', {
      message: response.data?.message,
    })
  }

  /**
   * 서비스 점검
   * @method
   * @memberof ErrorService
   */
  static serviceUnavailable() {
    console.log('gotoSystemInspection')
  }

  /**
   * 네트워크 오류
   * @method
   * @memberof ErrorService
   */
  static networkError() {
    console.log('gotoNetworkError')
  }
}
